import {
  DayOfWeek,
  HolidayHoursReponseV2,
  WorkingHoursReponseV2,
  WorkingHoursResponseV2,
} from '../../types/location.types';

const DAY_ORDER: Record<DayOfWeek, number> = {
  [DayOfWeek.Sunday]: 0,
  [DayOfWeek.Monday]: 1,
  [DayOfWeek.Tuesday]: 2,
  [DayOfWeek.Wednesday]: 3,
  [DayOfWeek.Thursday]: 4,
  [DayOfWeek.Friday]: 5,
  [DayOfWeek.Saturday]: 6,
};

export function normalizeHours(arr: WorkingHoursResponseV2[] = []) {
  return [...arr]
    .map(({ day, startTime, endTime }) => ({ day, startTime, endTime }))
    .sort((a, b) => {
      const d = (DAY_ORDER[a.day] ?? 0) - (DAY_ORDER[b.day] ?? 0);
      if (d !== 0) return d;
      if (a.startTime !== b.startTime)
        return a.startTime.localeCompare(b.startTime);
      return a.endTime.localeCompare(b.endTime);
    });
}

export function stableStringifyWorkingHours(v?: WorkingHoursReponseV2 | null) {
  if (!v) return '{"business":[],"delivery":[]}';
  const business = normalizeHours(v.business ?? []);
  const delivery = normalizeHours(v.delivery ?? []);
  return JSON.stringify({ business, delivery });
}

export function normalizeHolidayHours(arr: HolidayHoursReponseV2[] = []) {
  return [...arr]
    .map(({ date, startTime, endTime }) => ({ date, startTime, endTime }))
    .sort((a, b) =>
      a.date === b.date
        ? a.startTime === b.startTime
          ? a.endTime.localeCompare(b.endTime)
          : a.startTime.localeCompare(b.startTime)
        : a.date.localeCompare(b.date)
    );
}

/** Keep only fields that define the schedule and sort deterministically */
export function stableStringifyHolidayHours(
  arr?: HolidayHoursReponseV2[] | null
) {
  if (!Array.isArray(arr)) return '[]';
  const normalized = normalizeHolidayHours(arr);
  return JSON.stringify(normalized);
}
